import {onViewAppeared, onViewDisappeared} from "../../../api/index";

const [
    _hasInited,
    _onLoadSuccessListenerList,
    _onLoadFailureListenerList,
    _onLoadListenerList,
    _isLoaded,
    _hasShowed,
    _viewAppeared,
] = [
    Symbol('_hasInited'),
    Symbol('_onLoadSuccessListenerList'),
    Symbol('_onLoadFailureListenerList'),
    Symbol('_onLoadListenerList'),
    Symbol('_hasShowed'),
    Symbol('_viewAppeared'),
]

import NativeComponent from "../native/NativeComponent"
// import $ from "jquery"
//import Webview from "@component/native/visible/Webview"
import Slot from "./Slot";
//const Webview = require('../component/native/visible/Webview')
import Platform from '../../platform'
import { onNativeSetStyle, onNativeSetStyleList, onNativeShowCloseButton, onNativeHideCloseButton, onNativeSetVolume, onNativeSetVideoPlayMode } from '../../../api/nativeCalledListener'
import * as util from '../../../common/util'
import App from "../../App";

class Template {
    constructor(props = {}) {
        const {container} = props
        this.container = container

        // 插槽列表
        this.slotList = []

        this.unit = props.unit || {}
        this[_hasInited] = false
        this[_isLoaded] = false
        this[_onLoadSuccessListenerList] = []
        this[_onLoadFailureListenerList] = []
        this[_onLoadListenerList] = []
        this.hasShowed = false
        //webviewshow时 sdk传递的数据
        this.adShowedData ={}
        this.viewHasAppeared = false

        this.platform = Platform.getInstance()

        window.addEventListener('resize', () => {
            setTimeout(() => {
                console.warn('生命周期方法调用')
                this.resetSlotsRect()
                console.warn('生命周期方法被调用+')
            }, 0)
            //this.resetSlotsRect()
        }, false)

        onViewAppeared(() => {
            this.viewHasAppeared = true
            this.viewAppeared()
        })
        onViewDisappeared(() => {
            this.viewHasAppeared = false
            this.viewDisappeared()
        })

        // 通过 h5_debug_mode=1 开启 vConsole
        try {
            let h5DebugMode = util.getPageUrlParams('h5_debug_mode');
            let isH5DebugModeOpened = Number(h5DebugMode) === 1
            console.log({h5DebugMode, isH5DebugModeOpened})
            window.h5DebugMode = h5DebugMode
            if (isH5DebugModeOpened) {
                window.App = App
                App.enableDebugMode()
            }
        } catch (e) {
            console.error('加载 vConsole 失败', e)
        }
    }

    set hasShowed(showed) {
        this[_hasShowed] = showed
    }

    get hasShowed() {
        return this[_hasShowed]
    }


    set viewHasAppeared(viewAppeared) {
        this[_viewAppeared] = viewAppeared
    }

    get viewHasAppeared() {
        return this[_viewAppeared]
    }

    /**
     * 视图被展示
     */
    viewAppeared() {
    }

    /**
     * 视图被隐藏
     */
    viewDisappeared() {
    }

    /**
     * 生命周期方法，当广告模板在广告位展示出来时被调用
     * 如果在adShow之前没有初始化模板(调用init方法)，则会在adShow的时候初始化
     */
    adShowed(data) {
        // this.adShowTime = Date.now(); // webviewshow时间
        if (!this[_hasInited]) {
            this.init()
        } else {
            // console.log('模板已被init 无需重复初始化.')
        }

        // webviewshow之后返回数据
        this.adShowedData = data
        this.reward = this.adShowedData && this.adShowedData.param && this.adShowedData.param.reward
        App.adShowTime = Date.now()

        // 模版已被展示
        this.hasShowed = true
        /*setTimeout(()=>{
            console.warn('生命周期方法，当广告模板在广告位展示出来时被调用')
            this.resetSlotsRect()
            console.warn('生命周期方法，当广告模板在广告位展示出来时被调用+')
            setTimeout(()=>{
                console.warn('10s后 生命周期方法，当广告模板在广告位展示出来时被调用')
                this.resetSlotsRect()
                console.warn('10s后 生命周期方法，当广告模板在广告位展示出来时被调用+')
            },3000)
        },0)*/

        console.warn('生命周期方法调用')
        this.resetSlotsRect()
        console.warn('生命周期方法被调用+')
    }

    /**
     * 初始化模板
     */
    init() {
        this[_hasInited] = true

        this.initComponents()
        this.initSlots()
        this.bindEvent()

        this._isLoadFinish().then(() => {
            this[_isLoaded] = true
            this[_onLoadSuccessListenerList].forEach(listener => listener())
            this[_onLoadListenerList].forEach(listener => {
                listener.successListener()
            })
        }).catch((e) => {
            this[_isLoaded] = true
            this[_onLoadFailureListenerList].forEach(listener => listener())
            this[_onLoadListenerList].forEach(listener => {
                listener.failureListener(e)
            })
        })
    }

    /**
     * 初始化模板包含的各个组件
     */
    initComponents() {
        console.log('initComponents 接口方法，未实现', this)
    }

    /**
     * 初始化
     */

    /*init({JsBridgeRes}) {

        // 针对 Promise 添加调试监听
        window.addEventListener("unhandledrejection", event => {
            console.warn(`UNHANDLED PROMISE REJECTION: ${event.reason}`, {event});
        });

        // iOS 下禁用滑动反弹
        if (_device().isiOS) {
            VideoBridgeToggleBouncesOff()
        }

        // this.bindEvent()
    }*/


    /**
     * 绑定事件
     */
    bindEvent() {
        this.bindPageEvent()
        this.bindNativeEvent()
    }

    /**
     * 绑定h5页面各个事件
     */
    bindPageEvent() {
        console.log('bindPageEvent 接口方法，未实现', this)
    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {
        // console.log('bindNativeEvent 接口方法，未实现', this)
        console.log('bindNativeEvent 接口方法--')
        this.registerNativeSetStyle()
        this.registerNativeSetStyleList()
        this.registerNativeSetCloseButton()
        this.registerNativeSetVolume()
    }

    /**
     * 注册sdk调用设置样式方法
     */
    registerNativeSetStyle() {
        const legalKeyMap = {
            "marginTop": {unit: "px"},
            "marginRight": {unit: "px"},
            "marginBottom": {unit: "px"},
            "marginLeft": {unit: "px"},
            "paddingTop": {unit: "px"},
            "paddingRight": {unit: "px"},
            "paddingBottom": {unit: "px"},
            "paddingLeft": {unit: "px"},

            "backgroundColor": {},
            "fontSize": {unit: "px"},
            "color": {},
            "fontFamily": {}
        }
        const targetKeys = ['title', 'subTitle', 'button', 'icon', 'container', 'mediaContent']
        onNativeSetStyle((params = {}, resolve, reject) => {
            const {target, values} = params
            console.log('onNativeSetStyle=====>', target, values)
            if (target && values && (targetKeys.indexOf(target) !== -1)) {
                const attrKeys = Object.keys(values)
                const targetEls = document.querySelectorAll(`[mtg-el-name=${target}]`)
                const targetElList = [].slice.call(targetEls)
                targetElList.forEach(el => {
                    attrKeys.forEach(key => {
                        if (legalKeyMap[key]) {
                            el.style[key] = values[key] + (legalKeyMap[key].unit || '')
                        }
                    })
                })
                resolve()
            } else {
                reject('参数不正确')
            }
        })
    }


    /**
     * 注册sdk调用设置样式方法
     */
    registerNativeSetStyleList() {
        const legalKeyMap = {
            "paddingTop": {unit: "px"},
            "paddingRight": {unit: "px"},
            "paddingBottom": {unit: "px"},
            "paddingLeft": {unit: "px"},

            "backgroundColor": {},
            "fontSize": {unit: "px"},
            "color": {},
            "fontFamily": {}
        }
        const targetKeys = ['title', 'subTitle', 'button', 'icon', 'container', 'mediaContent']
        onNativeSetStyleList((params = {}, resolve, reject) => {
            const {list = []} = params
            console.log('onNativeSetStyleList=====>', list)
            list.forEach(styleItem => {
                const {target, values} = styleItem
                if (target && values && (targetKeys.indexOf(target) !== -1)) {
                    const attrKeys = Object.keys(values)
                    const targetEls = document.querySelectorAll(`[mtg-el-name=${target}]`)
                    console.log(`[mtg-el-name=${target}]`, targetEls)
                    const targetElList = [].slice.call(targetEls)
                    targetElList.forEach(el => {
                        attrKeys.forEach(key => {
                            if (legalKeyMap[key]) {
                                el.style[key] = values[key] + (legalKeyMap[key].unit || '')
                            }
                        })
                    })
                    resolve()
                } else {
                    reject('参数不正确')
                }
            })

        })
    }

    /**
     * 注册sdk调用设置关闭按钮方法
     */
    registerNativeSetCloseButton() {
        onNativeShowCloseButton((params = {}, resolve, reject) => {
            this.showCloseBtn && this.showCloseBtn().then(() => resolve()).catch(() => reject())
        })
        onNativeHideCloseButton((params = {}, resolve, reject) => {
            this.hideCloseBtn && this.hideCloseBtn().then(() => resolve()).catch(() => reject())
        })
    }

    /**
     * 注册sdk调用设置音量方法
     */
    registerNativeSetVolume() {
        console.log('注册静音registerNativeSetVolume')
        const MUTE_STATE = {
            TRUE: 1,
            FALSE: 2
        }
        onNativeSetVolume((params = {}, resolve, reject) => {
            if (!this.videoPlayer) {
                return
            }
            const {mute} = params // mute: 1 静音 ，2 非静音
            let muteOpt = undefined
            console.log('静音', mute)
            if (mute === MUTE_STATE.TRUE) {
                muteOpt = true
            } else if (mute === MUTE_STATE.FALSE) {
                muteOpt = false
            } else {
                reject('mute参数错误： mute=', mute)
                return false
            }

            let ret = this.videoPlayer.setMuted(muteOpt)
            if (ret) {
                resolve()
            } else {
                reject('当前设备版本不支持设置静音')
            }
        })
    }

    /**
     * 注册sdk调用设置音量方法
     */
    registerNativeSetVideoPlayMode(cb) {
        cb && onNativeSetVideoPlayMode(cb)
    }

    /**
     * 添加其他模板或组件到当前模板上上
     * @param component
     * @param rect
     * @returns {*}
     */
    append(component, rect) {
        let ret
        if (component instanceof NativeComponent) {
            ret = this.container.append(component, rect)
        } else if (component instanceof Template) {
            ret = this.container.append(component.container, rect)
        } else {
            console.error('模板无法append到目标组件')
            ret = new Promise((resolve, reject) => reject(new Error('模板无法append到目标组件')))
        }
        return ret
    }

    /**
     * 添加到其他模板或组件上
     * @param component
     * @param rect
     * @returns {*}
     */
    appendTo(component, rect) {
        let ret
        if (component instanceof NativeComponent) {
            ret = this.container.appendTo(component, rect)
        } else if (component instanceof Template) {
            ret = this.container.appendTo(component.container, rect)
        } else {
            console.error('模板无法appendTo目标组件')
            ret = new Promise((resolve, reject) => reject(new Error('模板无法appendTo目标组件')))
        }
        return ret
    }

    show() {
        let ret
        if (this.container instanceof NativeComponent) {
            ret = this.container.show()
        }
        return ret || new Promise()
    }

    hide() {
        let ret
        if (this.container instanceof NativeComponent) {
            ret = this.container.hide()
        }
        return ret || new Promise()
    }

    /**
     * 根据id获取木板上的插槽
     * @param id {String}
     * @returns {Array}
     */
    getSlotById(id) {
        return this.slotList.filter(slot => {
            return slot.id === id
        })[0]
    }

    /**
     * 将子模板或组件插入插槽
     * @param id {Number} 插槽id
     * @param component {Template|Component} 模板或组件实例
     */
    slotIn(id, component) {
        const slot = this.getSlotById(id)
        if (slot) {
            slot.slotIn(component)
            // console.warn("插槽插入成功",slot,id,component,this)
        } else {
            console.warn("插槽id不匹配", slot, id, component, this)
        }
    }

    /**
     * 将子模板或组件插入插槽并显示
     * @param id {Number} 插槽id
     * @param component {Template|Component} 模板或组件实例
     */
    slotInAndShow(id, component) {
        const slot = this.getSlotById(id)
        if (slot) {
            slot.slotIn(component)
            component.show && component.show()
            // console.warn("插槽插入成功",slot,id,component,this)
        } else {
            console.warn("插槽id不匹配", slot, id, component, this)
        }
    }

    /**
     * 将子模板或组件插入插槽（插入到宿主容器的下方）
     * @param id {Number} 插槽id
     * @param component {Template|Component} 模板或组件实例
     */
    slotInBelow(id, component) {
        const slot = this.getSlotById(id)
        if (slot) {
            slot.slotInBelow(component)
            // console.warn("插槽插入成功",slot,id,component,this)
        } else {
            console.warn("插槽id不匹配", slot, id, component, this)
        }
    }

    slotOut(id, component) {
        const slot = this.getSlotById(id)
        if (slot) {
            slot.slotOut(component)
        } else {
            console.warn("未找到id匹配的插槽", slot, id, component, this)
        }
    }


    /**
     * 初始化插槽
     */
    initSlots() {
        //this.container = new Webview()
        console.log("初始化插槽")
        let slotEls = document.querySelectorAll('.slot')
        slotEls = [].slice.call(slotEls);
        slotEls.forEach((el, i) => {
            const rect = this.getDomRect(el)
            //rect = {"top":10,"bottom":320,"left":0,"right":30,"width":80,"height":80}
            this.slotList.push(new Slot({
                id: el.id,
                rect,
                hostContainer: this.container
            }))
        })
    }

    getOffsetTop(el) {
        return el.offsetParent
            ? el.offsetTop + this.getOffsetTop(el.offsetParent)
            : el.offsetTop
    }

    getOffsetLeft(el) {
        return el.offsetParent
            ? el.offsetLeft + this.getOffsetLeft(el.offsetParent)
            : el.offsetLeft
    }

    getDomRect(el) {
        const elRect = el.getBoundingClientRect()
        const windowRect = document.documentElement.getBoundingClientRect()
        /*const rect = {
            //width: elRect.width,
            //height: elRect.height,
            left: elRect.left,
            right: windowRect.width - elRect.right,
            top: elRect.top,
            bottom: windowRect.height - elRect.bottom
        }*/

        //目前在安卓和ip6下表现很好，ipxr不行
        const rect = {
            //width: elRect.width,
            //height: elRect.height,
            left: elRect.left,
            right: window.innerWidth - elRect.right,
            top: elRect.top,
            bottom: window.innerHeight - elRect.bottom
        }
        //安卓下表现最好 需要在showad之前init
        /*const rect = {
            width: el.clientWidth,
            height: el.clientHeight,
            left: this.getOffsetLeft(el),
            top: this.getOffsetTop(el)
        }*/
        /*const rect = {
            width: elRect.width,
            height: elRect.height,
            left: elRect.left,
            top: elRect.top,
        }*/
        /*const rect = {
            width: elRect.width,
            height: elRect.height,
            left: elRect.left,
            //right: windowRect.width - elRect.right,
            top: elRect.top,
            //bottom: windowRect.height - elRect.bottom
        }*/
        /*const rect = {
            width: $(el).width(),
            height: $(el).height(),
            left: $(el).offset().left,
            top: $(el).offset().top
        }*/
        console.log('getBoundingClientRect=======>修正：', rect, windowRect, el.id)
        return rect
    }

    resetSlotsRect() {
        console.warn('begin 开始 插槽resize：', this.slotList)
        try {
            this.slotList.forEach(slot => {
                const id = slot.id
                let slotDom = document.getElementById(id)
                const rect = slotDom && this.getDomRect(slotDom)
                rect && slot.setRect(rect)
                console.warn('插槽resize：', id)
            })
        } catch (e) {
            console.warn('Error 插槽resize：', e)
        }
    }

    resetSlotRectById(id) {
        console.warn('begin 开始 插槽resize by id：', this.slotList)
        try {
            let slotDom = document.getElementById(id)
            const rect = slotDom && this.getDomRect(slotDom)
            const slot = (this.slotList.filter((item) => item.getId() == id))[0]
            rect && slot.setRect(rect)
            console.warn('插槽resize：', id)
        } catch (e) {
            console.warn('Error 插槽resize by id：', e)
        }
    }

    /**
     * 销毁组件
     */
    destory() {
        if (this.container && this.container.destory) {
            this.container.destory()
        }
        this.container = null
    }

    /**
     * 模板加载完成时触发
     * @returns {Promise<any>}
     */
    whenLoad() {
        return new Promise((resolve, reject) => {
            if (this[_isLoaded]) {
                resolve()
            } else {
                this[_onLoadListenerList].push({
                    successListener: resolve,
                    failureListener: reject
                })
            }
        })
    }

    onLoadSuccess(listener) {
        if (listener && ('function' === typeof listener)) {
            this[_onLoadSuccessListenerList].push(listener)
        } else {
            return new Promise((resolve) => {
                this[_onLoadSuccessListenerList].push(resolve)
            })
        }
    }

    onLoadFailure(listener) {
        if (listener && ('function' === typeof listener)) {
            this[_onLoadFailureListenerList].push(listener)
        } else {
            return new Promise((resolve) => {
                this[_onLoadSuccessListenerList].push(resolve)
            })
        }
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish() {
        return this.container && this.container.whenCreateSuccess ? this.container.whenCreateSuccess() : new Promise((resolve) => resolve())
    }
}

export default Template